document.addEventListener('DOMContentLoaded', function() {
    let slider = document.querySelector('.hero-slider');
    let slides = document.querySelectorAll('.hero-slide');
    let dots = document.querySelectorAll('.dot');
    let prevButton = document.querySelector('.prev-slide');
    let nextButton = document.querySelector('.next-slide');
    let currentIndex = 0;
    const totalSlides = slides.length;

    // Actualizar la diapositiva visible

  
    function updateSlide() {
      slider.style.transform = `translateX(-${currentIndex * 100}%)`;
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === currentIndex);
      });
    }

    // Mostrar la diapositiva siguiente
    nextButton.addEventListener('click', function() {
      currentIndex = (currentIndex + 1) % totalSlides;
      updateSlide();
    });

    // Mostrar la diapositiva anterior
    prevButton.addEventListener('click', function() {
      currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
      updateSlide();
    });

    // Controlar la navegación con los puntos
    dots.forEach((dot, index) => {
      dot.addEventListener('click', function() {
        currentIndex = index;
        updateSlide();
      });
    });

    // Inicializar la primera diapositiva
    updateSlide();
  });

  document.addEventListener('DOMContentLoaded', function() {
  const track = document.querySelector('.cards-slider-track');
  const slides = document.querySelectorAll('.cards-slide');
  const prevBtn = document.querySelector('.cards-prev-btn');
  const nextBtn = document.querySelector('.cards-next-btn');
  
  let currentIndex = 0;
  let slideInterval;
  const intervalTime = 5000; // 5 segundos

  // Mueve la pista del slider
  function updateSliderPosition() {
    track.style.transform = `translateX(-${currentIndex * 100}%)`;
  }

  // Avanzar
  function nextSlide() {
    currentIndex = (currentIndex + 1) % slides.length;
    updateSliderPosition();
  }

  // Retroceder
  function prevSlide() {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    updateSliderPosition();
  }

  // Auto-play
  function startSlider() {
    slideInterval = setInterval(nextSlide, intervalTime);
  }

  // Reinicia el contador si el usuario hace clic
  function resetInterval() {
    clearInterval(slideInterval);
    startSlider();
  }

  // Eventos de botones
  nextBtn.addEventListener('click', () => {
    nextSlide();
    resetInterval();
  });

  prevBtn.addEventListener('click', () => {
    prevSlide();
    resetInterval();
  });

  // Iniciar el auto-play al cargar
  startSlider();
});